import React from 'react'
import { useModal, Modal } from '@rst/ui-ts'
import { useStore } from 'effector-react'
import { $mapModal, closeMapModal } from '../../model/map'
import { lazyWithRetry } from '@rst/libs-ts'

const Map = lazyWithRetry(() => import('./map'))

const ModalMap = () => {
	const value = useStore($mapModal)
	const { connect } = useModal({ value })
	return (
		<Modal connect={connect} close={closeMapModal}>
			<React.Suspense fallback={() => null}>
				{value ? <Map /> : null}
			</React.Suspense>
		</Modal>
	)
}

export { ModalMap }
